import { DateAdapter } from '@angular/material/core';
import { DateRange } from '@angular/material/datepicker';

/**
 * The one place that turns the calendar's `selectedChange` into a range, so a change in Material's
 * selection events breaks here only. The first click sets a pending start; the second sets the end
 * and finishes the range, swapped when it is the earlier day. The panel provides Material's range
 * strategy only for the hover preview.
 */
export const nextRange = (
  clicked: Date | null,
  current: DateRange<Date>,
  adapter: DateAdapter<Date>,
): { range: DateRange<Date>; finished: boolean } => {
  if (!clicked) {
    return { range: current, finished: false };
  }
  if (current.start && !current.end) {
    const earlier = adapter.compareDate(clicked, current.start) < 0;
    return { range: earlier ? new DateRange(clicked, current.start) : new DateRange(current.start, clicked), finished: true };
  }
  return { range: new DateRange<Date>(clicked, null), finished: false };
};
